// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-container {
  position: absolute;
  top: -9999px;
  left: -9999px;
  width: 800px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
}
.pdf-container .pdf-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 30px;
}
.pdf-container .pdf-header .pdf-img-planejadora-sebrae {
  width: 10px;
}
.pdf-container .pdf-header-title {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.pdf-container .pdf-sub-header {
  display: flex;
  padding-bottom: 8px;
  margin-top: 15px;
  justify-content: center;
  background-color: #ced2d7;
}
.pdf-container .pdf-sub-header h4 {
  color: #626467;
}
.pdf-container .pdf-title {
  padding: 15px 0 5px;
}
.pdf-container .pdf-results-information {
  border-radius: 8px;
  background-color: #fff;
  border: 1px solid #e0e5eb;
}
.pdf-container .pdf-results-information__data {
  padding-left: 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: space-between;
  min-height: 46px;
  border-bottom: 1px solid #e0e5eb;
  margin-bottom: 0 !important;
}
.pdf-container .pdf-results-information__info {
  width: 50%;
  display: flex;
  align-items: center;
  word-wrap: break-word;
}
.pdf-container .pdf-results-information__value {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
}
.pdf-container .pdf-results-information__value.highlighted {
  min-height: 46px;
  background-color: #cfe2fc;
  padding: 4px 8px;
}
.pdf-container .pdf-inputs {
  padding-top: 10px;
}
.pdf-container .pdf-inputs .pdf-text-area, .pdf-container .pdf-inputs .pdf-text-inputs {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid rgb(182, 191, 200);
  background-color: rgb(245, 247, 250);
  min-height: 80px;
  margin: 4px 0 12px;
}
.pdf-container .pdf-inputs .pdf-text-area h6, .pdf-container .pdf-inputs .pdf-text-inputs h6 {
  white-space: pre-wrap;
  color: rgb(40, 42, 44);
}
.pdf-container .pdf-inputs .pdf-text-inputs {
  padding-top: 2px;
  min-height: 35px;
}
.pdf-container .pdf-output-data-header {
  display: flex;
  gap: 30;
  font-weight: bold;
  margin-bottom: 10px;
}
.pdf-container .pdf-output-data-header p,
.pdf-container .pdf-output-data-header div {
  flex: 1 1;
}
.pdf-container .pdf-output-data {
  display: flex;
  gap: 30;
}
.pdf-container .pdf-output-data h3,
.pdf-container .pdf-output-data p {
  flex: 1 1;
}
.pdf-container .pdf-results-observation {
  margin-top: 15px;
  padding: 10px 16px;
  border-radius: 20px;
  color: #626467;
  border: 1px solid #b6bfc8;
  line-height: 20px;
}
.pdf-container .pdf-results-observation ul li {
  padding-left: 16px;
}
.pdf-container .pdf-message-observation {
  text-align: end;
}
.pdf-container .pdf-message-observation p {
  padding-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/pdf-page/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AACJ;AACI;EACE,WAAA;AACN;AAEI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AAAN;AAIE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;AAFJ;AAII;EACE,cAAA;AAFN;AAME;EACE,mBAAA;AAJJ;AAOE;EACE,kBAAA;EACA,sBAAA;EACA,yBAAA;AALJ;AAOI;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EAEA,8BAAA;EACA,gBAAA;EACA,gCAAA;EACA,2BAAA;AANN;AASI;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AAPN;AAUI;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AARN;AAUM;EACE,gBAAA;EACA,yBAAA;EACA,gBAAA;AARR;AAaE;EACE,iBAAA;AAXJ;AAaI;EACE,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;AAXN;AAaM;EACE,qBAAA;EACA,sBAAA;AAXR;AAeI;EAGE,gBAAA;EACA,gBAAA;AAfN;AAmBE;EACE,aAAA;EACA,OAAA;EACA,iBAAA;EACA,mBAAA;AAjBJ;AAmBI;;EAEE,SAAA;AAjBN;AAqBE;EACE,aAAA;EACA,OAAA;AAnBJ;AAqBI;;EAEE,SAAA;AAnBN;AAuBE;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EAEA,iBAAA;AAtBJ;AAwBM;EACE,kBAAA;AAtBR;AA2BE;EACE,eAAA;AAzBJ;AA2BI;EACE,gBAAA;AAzBN","sourcesContent":[".pdf-container {\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  background-color: #fff;\n\n  .pdf-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-bottom: 30px;\n\n    .pdf-img-planejadora-sebrae {\n      width: 10px;\n    }\n\n    &-title {\n      display: flex;\n      align-items: center;\n      flex-direction: column;\n    }\n  }\n\n  .pdf-sub-header {\n    display: flex;\n    padding-bottom: 8px;\n    margin-top: 15px;\n    justify-content: center;\n    background-color: #ced2d7;\n\n    h4 {\n      color: #626467;\n    }\n  }\n\n  .pdf-title {\n    padding: 15px 0 5px;\n  }\n\n  .pdf-results-information {\n    border-radius: 8px;\n    background-color: #fff;\n    border: 1px solid #e0e5eb;\n\n    &__data {\n      padding-left: 16px;\n      display: flex;\n      flex-wrap: wrap;\n      align-items: stretch;\n      // align-items: center;\n      justify-content: space-between;\n      min-height: 46px;\n      border-bottom: 1px solid #e0e5eb;\n      margin-bottom: 0 !important;\n    }\n\n    &__info {\n      width: 50%;\n      display: flex;\n      align-items: center;\n      word-wrap: break-word;\n    }\n\n    &__value {\n      width: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background-color: transparent;\n\n      &.highlighted {\n        min-height: 46px;\n        background-color: #cfe2fc;\n        padding: 4px 8px;\n      }\n    }\n  }\n\n  .pdf-inputs {\n    padding-top: 10px;\n\n    .pdf-text-area {\n      padding: 8px;\n      border-radius: 4px;\n      border: 1px solid rgb(182, 191, 200);\n      background-color: rgb(245, 247, 250);\n      min-height: 80px;\n      margin: 4px 0 12px;\n\n      h6 {\n        white-space: pre-wrap;\n        color: rgb(40, 42, 44);\n      }\n    }\n\n    .pdf-text-inputs {\n      @extend .pdf-text-area;\n\n      padding-top: 2px;\n      min-height: 35px;\n    }\n  }\n\n  .pdf-output-data-header {\n    display: flex;\n    gap: 30;\n    font-weight: bold;\n    margin-bottom: 10px;\n\n    p,\n    div {\n      flex: 1;\n    }\n  }\n\n  .pdf-output-data {\n    display: flex;\n    gap: 30;\n\n    h3,\n    p {\n      flex: 1;\n    }\n  }\n\n  .pdf-results-observation {\n    margin-top: 15px;\n    padding: 10px 16px;\n    border-radius: 20px;\n    color: #626467;\n    border: 1px solid #b6bfc8;\n\n    line-height: 20px;\n    ul {\n      li {\n        padding-left: 16px;\n      }\n    }\n  }\n\n  .pdf-message-observation {\n    text-align: end;\n\n    p {\n      padding-top: 5px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
